import * as React from 'react';
import style from './Note.scss';
import { Text } from '../../PageElements/Text';

interface NoteProps {
  title: string;
  children: any;
  dataHook?: string;
  sideLineColor: string;
}

export const Note = ({
  title,
  children,
  dataHook,
  sideLineColor = '',
}: NoteProps) => {
  return (
    <div className={style.note + ` ${style[sideLineColor]}`}>
      <Text weight="bold" dataHook="details-subtitle">
        {title}
      </Text>
      {typeof children === 'string' ? (
        <Text dataHook={dataHook} weight="thin">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
};
